import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";

import { getLeaguesSuspensions } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "./leaguesNewQueryKeys";

export const useLeaguesSuspensions = (
  targetUsername?: string,
  sportId?: number
) => {
  const lang = useLocale();

  return useQuery({
    queryKey: [
      LeaguesNewQueryKeys.LeaguesSuspensions,
      targetUsername,
      sportId,
    ],
    queryFn: ({ signal }) =>
      getLeaguesSuspensions({
        signal,
        params: { lang, targetUsername, sportId },
      }),
  });
};
